<template>
  <div>
    <h2 class="imtil">基础信息</h2>
    <div class="wrap dd">
      <div class="masks"></div>
      <el-form ref="form" :model="form" class="formr" label-width="120px">
        <el-form-item label="姓名">
          <el-input v-model="form.personName"></el-input>
        </el-form-item>
        <el-form-item label="民族">
          <el-input v-model="form.nation"></el-input>
        </el-form-item>
        <el-form-item label="乡镇">
          <el-input v-model="form.townName"></el-input>
        </el-form-item>
        <el-form-item label="家庭住址">
          <el-input v-model="form.homeaddress"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="form" class="forml" label-width="90px">
        <el-form-item label="身份证号">
          <el-input v-model="form.identityNumber"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.telphone"></el-input>
        </el-form-item>
        <el-form-item label="村/社区">
          <el-input v-model="form.villageName"></el-input>
        </el-form-item>


      </el-form>
    </div>
    <h2 class="imtil">附件</h2>
    <div class="imgcon">
       <div class="demo-image__placeholder">
        <div class="block">
          <p class="demonstration">老人头像照片</p>
          <el-image :src="form.personPic" :preview-src-list="form.personPic?form.personPic.split(','):[]"></el-image>
        </div>
        <div class="block">
          <p class="demonstration">本人身份证</p>
          <el-image :src="form.idcardPic" :preview-src-list="form.idcardPic?form.idcardPic.split(','):[]">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <div class="block">
          <p class="demonstration">户口本原件</p>
          <el-image :src="form.regbookPic" :preview-src-list="form.regbookPic?form.regbookPic.split(','):[]">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <!-- <div class="block">
          <p class="demonstration">银行卡照片</p>
          <el-image :src="form.bankPic" :preview-src-list="form.bankPic?form.bankPic.split(','):[]">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div> -->
      </div>
    </div>
    <div style="text-align:center;margin-bottom:40px" v-show="show">
      <el-button type="success" @click="pass"><i class="el-icon-circle-check"></i> 审核通过</el-button>
      <el-button type="danger" @click="nopass"><i class="el-icon-circle-close"></i> 审核不通过</el-button>
    </div>
    <!--<div class="tim">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.timestamp"
          :timestamp2="123">
          {{activity.content}}
          <p style="font-size:13px;color:#909399" v-show="activity.timestamp">审核人:{{activity.name}}</p>
          <p style="font-size:13px;color:#909399" v-show="activity.examineRemark">原因:{{activity.examineRemark}}</p>
        </el-timeline-item>
      </el-timeline>
    </div>-->
  </div>
</template>
<script>
    import CryptoJS from 'crypto-js'
    import { Loading } from 'element-ui';
    const ossurl = 'http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/'
    export default {
        data(){
            return{
                activities:[],
                form:{
                    "nation": "",
                    "bankPic": "",
                    "agentTel": "",
                    "bankName": "",
                    "villageName": "",
                    "cityName": "",
                    "idcardPic": "",
                    "identityNumber": "",
                    "bankNo": "",
                    "townName": "",
                    "bankType": "",
                    "homeaddress": "",
                    "regbookPic": "",
                    "frommodel": "",
                    "personPic": "",
                    "personName": "",
                    "telphone": "",
                    "workType": "",
                    "provinceName": "",
                    "countryName": "",
                },
                urls: [

                ],
                show:""
            }

        },
        methods:{
            //审核通过
            pass(){
                this.$confirm('是否审核通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',

                }).then(() => {
                    Loading.service();
                    var data={
                        examineId: sessionStorage.getItem("examineId"),
                        examineState:1,
                        remark:"",
                        userId:1
                    };
                    this.$api.getlist.examine(data).then((res) => {
                        let loadingInstance = Loading.service();
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            loadingInstance.close();
                        });
                        if(res.code==200){
                            this.$message({
                                type: 'success',
                                message: res.data
                            });
                            
                        }else{
                            this.$message({
                                type: 'info',
                                message: res.message
                            });
                        }
                        this.$router.back();
                        // 关闭当前标签
                        let closeAll = document.querySelectorAll(".el-icon-close");
                        for(let j = 0, len = closeAll.length; j < len; j++) {
                            if (closeAll[j].previousSibling != null && closeAll[j].previousSibling.innerText === "高龄登记") {
                                closeAll[j].click();
                                return;
                            }
                        }
                    }).catch((res) => {
                        let loadingInstance = Loading.service();
                        that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            loadingInstance.close();
                        });
                        this.$message({
                            type: 'info',
                            message: '操作失败!'+res
                        });
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            //审核不通过
            nopass(){
                var that=this
                this.$prompt('请输入原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',

                }).then(({ value }) => {
                    if(value){
                        Loading.service();
                        var data={
                            examineId: sessionStorage.getItem("examineId"),
                            examineState:2,
                            remark:value
                        };
                        this.$api.getlist.examine(data).then((res) => {
                            let loadingInstance = Loading.service();
                            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                loadingInstance.close();
                            });
                            if(res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                                // this.$router.push({
                                //   name:"Xxsh"
                                // })
                            }else{
                                this.$message({
                                    type: 'info',
                                    message: res.message
                                });
                            }
                            this.$router.back();
                            // 关闭当前标签
                            let closeAll = document.querySelectorAll(".el-icon-close");
                            for(let j = 0, len = closeAll.length; j < len; j++) {
                                if (closeAll[j].previousSibling != null && closeAll[j].previousSibling.innerText === "高龄登记") {
                                    closeAll[j].click();
                                    return;
                                }
                            }
                        }).catch((res) => {
                            let loadingInstance = Loading.service();
                            that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                loadingInstance.close();
                            });
                            this.$message({
                                type: 'info',
                                message: '操作失败!'+res
                            });
                        });

                    }else{
                        let loadingInstance = Loading.service();
                        that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            loadingInstance.close();
                        });
                        that.$message({
                            type: 'info',
                            message: '请输入原因'
                        });
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消输入'
                    });
                });
            },
            decrypt(word){
                var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
                var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
                return CryptoJS.enc.Utf8.stringify(decrypt).toString();
            }

        },
        created(){
           // debugger
            this.activities=JSON.parse(sessionStorage.getItem("progress"))
            this.show=this.$route.query.show
            // if(this.$route.query.info){
            //     sessionStorage.setItem("info",this.$route.query.info)
            // }

            //if(this.$route.query.info){
            var a=JSON.stringify(this.$route.query)
            sessionStorage.setItem("items",a)
            // }
            this.form =JSON.parse(sessionStorage.getItem("info"))

            this.form.personName=this.decrypt(this.form.personName)
            this.form.identityNumber=this.decrypt(this.form.identityNumber)
            this.form.telphone=this.decrypt(this.form.telphone)
            this.form.personPic = this.form.personPic?ossurl+this.form.personPic:null;
            this.form.bankPic = this.form.bankPic?ossurl+this.form.bankPic:null;
            this.form.regbookPic = this.form.regbookPic?ossurl+this.form.regbookPic:null;
            this.form.idcardPic = this.form.idcardPic?ossurl+this.form.idcardPic:null;
        }

    }
</script>
<style>

  .wrap{
    overflow: hidden;
    position: relative;
  }
  .demo-image__placeholder{
    display: flex !important;
    justify-content: space-around !important;
  }
  .demonstration{
    text-align: center;
  }
  .tim{
    border: 1px solid lightgray;
    padding: 10px;
    width: 180px;
    position: fixed;
    right: 0;
    top: 30%;
    border-radius: 10px;
    background:#ffffff

  }
  .demo-image__placeholder{
  width: 100% !important;
}
  .masks{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200
  }
  .forml{
    float: left;
    width: 45%
  }
  .formr{
    float: left;
    width: 40%;
    margin-left: 20px
  }
  .imgcon{
    margin: 0 auto;
    box-shadow: 0 0 15px lightgray;
    overflow: hidden;
    margin-bottom: 40px;
    height: 500px;
  }
  .block{
    width: 20% !important;
    text-align: center;
    margin-left: 10px;
  }
  .block{
    float: left;
    height: 100%;
    margin-right: 20px
  }
  .imtil{
    padding:0 0 20px 0
  }
</style>



// WEBPACK FOOTER //
// src/views/Myvue/weifangshiReg.vue